import { render, staticRenderFns } from "./StepsThird.vue?vue&type=template&id=b5afc064&scoped=true"
import script from "./StepsThird.vue?vue&type=script&lang=js"
export * from "./StepsThird.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5afc064",
  null
  
)

export default component.exports